import React from 'react'
import PropTypes from 'prop-types'

const IconEstimatedTime = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='51'
      height='56'
      viewBox='0 0 45 56'
      fill='none'
    >
      <path
        d='M23.292 55.2216C35.6035 55.2216 45.5839 45.2412 45.5839 32.9297C45.5839 20.6182 35.6035 10.6377 23.292 10.6377C10.9805 10.6377 1 20.6182 1 32.9297C1 45.2412 10.9805 55.2216 23.292 55.2216Z'
        fill='#D8D8D8'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M23.2917 35.0239C24.449 35.0239 25.3871 34.0857 25.3871 32.9284C25.3871 31.7712 24.449 30.833 23.2917 30.833C22.1344 30.833 21.1963 31.7712 21.1963 32.9284C21.1963 34.0857 22.1344 35.0239 23.2917 35.0239Z'
        fill='#5A5654'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M43.3377 11.4589L40.7852 13.877L43.4475 16.6873L46 14.2693L43.3377 11.4589Z'
        fill='#FFD356'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.1934 22.8311L23.2916 32.9293'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25.0202 7.46384V4.90672H28.2876V1H18.2959V4.90672H21.5633V7.46384'
        fill='#FFD356'
      />
      <path
        d='M25.0202 7.46384V4.90672H28.2876V1H18.2959V4.90672H21.5633V7.46384'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

IconEstimatedTime.propTypes = {
  className: PropTypes.string
}

export default IconEstimatedTime
